export const products = [
  {
    id: 'prod-1',
    name: 'Motion Grid Pro',
    slug: 'motion-grid-pro',
    type: 'plugin' as const,
    shortDescription: 'Advanced grid layout builder with motion animations for Elementor.',
    description: 'Motion Grid Pro transforms your Elementor pages with stunning animated grid layouts. Featuring parallax scrolling, staggered entrances, hover reveals, and over 50 preset grid patterns optimized for performance.',
    features: ['50+ preset layouts', 'Parallax & scroll animations', 'Staggered entrance effects', 'Fully responsive', 'Performance optimized'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20modern%20digital%20product%20mockup%20showing%20a%20WordPress%20plugin%20interface%20with%20a%20grid%20layout%20builder%20on%20a%20soft%20minimal%20background%20with%20subtle%20green%20and%20white%20tones%20clean%20UI%20design&width=600&height=400&seq=1&orientation=landscape',
    gallery: [],
    status: 'published' as const,
    priceFrom: 29,
    sales: 1247,
    rating: 4.9,
    reviews: 312,
    version: '2.4.1',
    createdAt: '2024-01-15',
    updatedAt: '2025-04-20',
  },
  {
    id: 'prod-2',
    name: 'Loop Grid Filters',
    slug: 'loop-grid-filters',
    type: 'addon' as const,
    shortDescription: 'Powerful AJAX filtering for Elementor Loop Grid with instant results.',
    description: 'Add advanced AJAX filtering capabilities to your Elementor Loop Grid widgets. Supports taxonomy filters, search, range sliders, and custom fields with instant no-reload results.',
    features: ['AJAX instant filtering', 'Taxonomy & custom field filters', 'Range slider support', 'URL parameter sync', 'Facet counts'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20modern%20digital%20product%20mockup%20showing%20a%20filter%20panel%20UI%20with%20checkboxes%20sliders%20and%20search%20on%20a%20clean%20minimal%20background%20with%20soft%20green%20and%20white%20tones%20professional%20design&width=600&height=400&seq=2&orientation=landscape',
    gallery: [],
    status: 'published' as const,
    priceFrom: 19,
    sales: 892,
    rating: 4.8,
    reviews: 198,
    version: '1.6.2',
    createdAt: '2024-03-10',
    updatedAt: '2025-03-15',
  },
  {
    id: 'prod-3',
    name: 'Motion Portfolio Theme',
    slug: 'motion-portfolio-theme',
    type: 'theme' as const,
    shortDescription: 'A premium portfolio WordPress theme for creative agencies and freelancers.',
    description: 'Motion Portfolio is a premium WordPress theme designed for creative agencies, designers, and photographers. Features bold typography, smooth page transitions, and integrated motion effects.',
    features: ['One-click demo import', 'Dark & light mode', 'Smooth page transitions', 'Portfolio layouts', 'WooCommerce ready'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20modern%20WordPress%20theme%20mockup%20showing%20a%20creative%20portfolio%20website%20with%20bold%20typography%20and%20smooth%20transitions%20on%20a%20clean%20minimal%20background%20with%20soft%20green%20and%20white%20tones&width=600&height=400&seq=3&orientation=landscape',
    gallery: [],
    status: 'published' as const,
    priceFrom: 49,
    sales: 534,
    rating: 4.7,
    reviews: 87,
    version: '3.1.0',
    createdAt: '2024-02-20',
    updatedAt: '2025-05-01',
  },
  {
    id: 'prod-4',
    name: 'Elementor Starter Kit',
    slug: 'elementor-starter-kit',
    type: 'template' as const,
    shortDescription: 'Complete landing page templates for Elementor with 30+ ready blocks.',
    description: 'A comprehensive starter kit with over 30 pre-designed Elementor blocks, 5 full landing pages, and a design system. Perfect for agencies that need to deliver fast.',
    features: ['30+ blocks', '5 full landing pages', 'Design system included', 'Global styles', 'Mobile optimized'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20modern%20digital%20product%20mockup%20showing%20a%20collection%20of%20website%20template%20blocks%20and%20landing%20page%20previews%20on%20a%20clean%20minimal%20background%20with%20soft%20green%20and%20white%20tones&width=600&height=400&seq=4&orientation=landscape',
    gallery: [],
    status: 'published' as const,
    priceFrom: 39,
    sales: 2103,
    rating: 4.9,
    reviews: 445,
    version: '1.2.0',
    createdAt: '2024-04-05',
    updatedAt: '2025-04-10',
  },
  {
    id: 'prod-5',
    name: 'Motion Forms Builder',
    slug: 'motion-forms-builder',
    type: 'plugin' as const,
    shortDescription: 'Advanced form builder with conditional logic, multi-step, and file uploads.',
    description: 'Build complex forms with conditional logic, multi-step workflows, file uploads, and integrations. Includes over 20 field types and real-time validation.',
    features: ['20+ field types', 'Conditional logic', 'Multi-step forms', 'File uploads', 'Zapier / Webhook integration'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20modern%20form%20builder%20UI%20mockup%20showing%20drag%20and%20drop%20fields%20conditional%20logic%20and%20multi%20step%20workflow%20on%20a%20clean%20minimal%20background%20with%20soft%20green%20and%20white%20tones&width=600&height=400&seq=5&orientation=landscape',
    gallery: [],
    status: 'published' as const,
    priceFrom: 35,
    sales: 678,
    rating: 4.6,
    reviews: 156,
    version: '1.8.0',
    createdAt: '2024-05-12',
    updatedAt: '2025-03-28',
  },
  {
    id: 'prod-6',
    name: 'Ecommerce Template Pack',
    slug: 'ecommerce-template-pack',
    type: 'template' as const,
    shortDescription: 'Complete WooCommerce store templates: shop, cart, checkout, product.',
    description: 'A complete set of WooCommerce templates designed for conversion. Includes shop grid, product detail, cart, checkout, and thank-you pages with integrated upsells.',
    features: ['Shop grid layouts', 'Product detail variants', 'Cart & checkout', 'Upsell templates', 'Quick view modal'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20modern%20ecommerce%20website%20template%20mockup%20showing%20product%20grid%20and%20checkout%20pages%20on%20a%20clean%20minimal%20background%20with%20soft%20green%20and%20white%20tones%20professional%20design&width=600&height=400&seq=6&orientation=landscape',
    gallery: [],
    status: 'published' as const,
    priceFrom: 59,
    sales: 412,
    rating: 4.8,
    reviews: 98,
    version: '1.0.5',
    createdAt: '2024-06-18',
    updatedAt: '2025-04-25',
  },
  {
    id: 'prod-7',
    name: 'Motion Icon Library',
    slug: 'motion-icon-library',
    type: 'asset' as const,
    shortDescription: '2,000+ animated icons for web projects with Lottie and SVG formats.',
    description: 'A massive library of over 2,000 animated icons in Lottie, SVG, and JSON formats. Perfect for web projects, apps, and presentations. Includes color customization tools.',
    features: ['2000+ icons', 'Lottie & SVG formats', 'Color customization', 'Categories & search', 'Regular updates'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20modern%20digital%20product%20mockup%20showing%20a%20grid%20of%20colorful%20animated%20icons%20and%20icons%20library%20UI%20on%20a%20clean%20minimal%20background%20with%20soft%20green%20and%20white%20tones&width=600&height=400&seq=7&orientation=landscape',
    gallery: [],
    status: 'published' as const,
    priceFrom: 19,
    sales: 3456,
    rating: 4.9,
    reviews: 678,
    version: '4.0.0',
    createdAt: '2023-11-01',
    updatedAt: '2025-05-05',
  },
  {
    id: 'prod-8',
    name: 'Motion Admin App',
    slug: 'motion-admin-app',
    type: 'app' as const,
    shortDescription: 'A React admin dashboard template with dark mode and data visualizations.',
    description: 'A production-ready React admin dashboard template featuring dark/light mode, data visualization components, tables, forms, and authentication pages. Built with React, Tailwind, and Recharts.',
    features: ['Dark & light mode', 'Data charts', 'Tables & forms', 'Auth pages', '50+ components'],
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20modern%20admin%20dashboard%20UI%20mockup%20showing%20data%20charts%20tables%20and%20sidebar%20navigation%20on%20a%20clean%20minimal%20background%20with%20soft%20green%20and%20white%20tones%20dark%20mode%20preview&width=600&height=400&seq=8&orientation=landscape',
    gallery: [],
    status: 'published' as const,
    priceFrom: 49,
    sales: 723,
    rating: 4.7,
    reviews: 134,
    version: '2.0.1',
    createdAt: '2024-07-22',
    updatedAt: '2025-04-18',
  },
];

export const productTypes = [
  { value: 'plugin', label: 'Plugins', count: 2 },
  { value: 'theme', label: 'Themes', count: 1 },
  { value: 'template', label: 'Templates', count: 2 },
  { value: 'addon', label: 'Addons', count: 1 },
  { value: 'asset', label: 'Assets', count: 1 },
  { value: 'app', label: 'Apps', count: 1 },
] as const;